import { pickLocale } from './locale'

const en = {
  title: 'Say something.',
  text: 'A question, a bug, an idea, a compliment. We read everything and answer quickly. We are still around, after all.',
}

const fr = {
  title: 'Dites quelque chose.',
  text: 'Une question, un bug, une idée, un compliment. On lit tout et on répond vite. On est encore là, après tout.',
}

export function getContactContent(language) {
  return pickLocale({ en, fr }, language)
}
